import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import RiskPoolSharingProvider from './context';
import { AppContext } from '../../../context';
import RiskPoolSharingList from './List';
import SearchOrganizations from './SearchOrganizations';

const RiskPoolSharing: React.FC = () => {
  const { enforcePermissions } = React.useContext(AppContext);

  return (
    <RiskPoolSharingProvider>
      <Routes>
        <Route
          path=''
          element={enforcePermissions(['addRelatedOrg'], <RiskPoolSharingList />)}
        />
        <Route
          path='add'
          element={enforcePermissions(['addRelatedOrg'], <SearchOrganizations />)}
        />
      </Routes>
    </RiskPoolSharingProvider>
  );
};

export default RiskPoolSharing;